import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

import { ConversationActions } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMessageList/SocialInboxHeader/SocialInboxActions/ConversationActions';

export const SocialInboxActions = () => {
    const { currentSocialInbox } = useSocialInboxNavigation();

    if (currentSocialInbox === SOCIAL_INBOX_META.dm.key) {
        return null;
    }

    return <ConversationActions />;
};
